/**
 * The answer box at the top of the ⌘K palette when the query is a budget
 * question (threads/customer-billing-budget/mockup-access.html §3). It shows
 * the number; the rows under it (open, export) are ordinary palette rows.
 */
import { cn } from "@/lib/utils";
import type { BudgetAnswer, BudgetHealth } from "./model";

const DOT: Record<BudgetHealth, string> = { good: "#1c6b45", warn: "#b27a0f", over: "#b42318" };

export function BudgetAnswerCard({ answer }: { answer: BudgetAnswer }) {
    if (answer.kind === "over") {
        return (
            <div className="mx-2 my-1.5 rounded-lg border bg-background px-3 py-2.5" data-testid="budget-answer">
                <div className="text-[15px] font-black tracking-tight">{answer.headline}</div>
            </div>
        );
    }
    return (
        <div className="mx-2 my-1.5 rounded-lg border bg-background px-3 py-2.5" data-testid="budget-answer">
            <div className="flex items-center gap-2">
                {answer.health && (
                    <span
                        aria-hidden
                        className="inline-block h-2.5 w-2.5 rounded-full"
                        style={{ background: DOT[answer.health] }}
                    />
                )}
                <span className="text-2xl font-black tabular-nums tracking-tight">{answer.headline}</span>
            </div>
            <div className={cn("mt-0.5 text-[12.5px] leading-snug")}>{answer.sentence}</div>
            {answer.detail && <div className="mt-0.5 text-[11.5px] text-muted-foreground">{answer.detail}</div>}
        </div>
    );
}
